import React from 'react'
import { Snackbar } from '@dasa-health/alma-react'
import { useWindowSize } from 'redesign/hooks/useWindowSize'
import { useSnackbar } from 'redesign/hooks/useSnackbar'

export const CustomSnackbar = () => {
    const { snackbarProps, onCloseSnackbar } = useSnackbar()
    const { windowSize } = useWindowSize()

    return (
        <Snackbar
            anchorOrigin={{ vertical: !windowSize.sm ? 'top' : 'bottom' }}
            data-testid="snackbar"
            onClose={() => onCloseSnackbar()}
            {...snackbarProps}
            sx={{
                zIndex: 50,
                padding: '1.5rem 1rem 1rem',
            }}
        />
    )
}
